// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  height: 100vh;
  width: 100vw;
  background-color: rgba(189, 195, 199, 0.6);
}
`, "",{"version":3,"sources":["webpack://./src/app/Controls/Core/WizardStepBox.less"],"names":[],"mappings":"AAIA;EACE,aAAA;EACA,YAAA;EACA,0CAAA;AAHF","sourcesContent":["@import '~common-controls/Style/Colors.less';\n\n\n\n.container {\n  height: 100vh;\n  width: 100vw;\n  background-color: rgba(189, 195, 199, 0.6);\n  // display: flex;\n  // justify-content: center;\n  // align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
